import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import * as researchersActions from './um-researcher.actions';
import { UmResearcher } from 'src/app/models/um-researcher';

export interface UmResearcherState extends EntityState<UmResearcher> {
  loadingUmResearchers: boolean;
  umResearchersLoaded: boolean;
  selectedUmResearcher: UmResearcher;
}

export const umResearcherAdapter: EntityAdapter<UmResearcher> = createEntityAdapter<UmResearcher>({});

export const initialUmResearcherState: UmResearcherState = umResearcherAdapter.getInitialState({
  loadingUmResearchers: false,
  umResearchersLoaded: false,
  selectedUmResearcher: null,
});

export const reducer = createReducer(
  initialUmResearcherState,
  on(researchersActions.getUmResearchers, (state) => {
    return umResearcherAdapter.removeAll({
      ...state,
      loadingUmResearchers: true,
      umResearchersLoaded: false,
    });
  }),
  on(researchersActions.getUmResearchersSuccess, (state, { researchers }) => {
    return umResearcherAdapter.setAll(researchers, {
      ...state,
      loadingUmResearchers: false,
      umResearchersLoaded: true,
    });
  }),
  on(researchersActions.getUmResearchersError, (state) => {
    return {
      ...state,
      loadingUmResearchers: false,
      umResearchersLoaded: false,
    };
  }),
  on(researchersActions.selectUmResearcherSuccess, (state, { selectedUmResearcher }) => {
    return {
      ...state,
      selectedUmResearcher,
    };
  }),
  on(researchersActions.activateUmResearcherSuccess, (state, { activatedResearcher }) => {
    return umResearcherAdapter.updateOne(
      { changes: activatedResearcher, id: activatedResearcher.id },
      {
        ...state,
      }
    );
  }),
  on(researchersActions.blockUmResearcherSuccess, (state, { blockedResearcher }) => {
    return umResearcherAdapter.updateOne(
      { changes: blockedResearcher, id: blockedResearcher.id },
      {
        ...state,
      }
    );
  }),
  on(researchersActions.changeUmResearcherRoleSuccess, (state, { upgradedResearcher }) => {
    return umResearcherAdapter.updateOne(
      { changes: upgradedResearcher, id: upgradedResearcher.id },
      {
        ...state,
      }
    );
  }),
  on(researchersActions.changeUmResearcherStudyTypeSuccess, (state, { changedStudyTypeResearcher }) => {
    return umResearcherAdapter.updateOne(
      {
        changes: changedStudyTypeResearcher,
        id: changedStudyTypeResearcher.id,
      },
      {
        ...state,
      }
    );
  }),
  on(researchersActions.disableUmResearcherTFASuccess, (state, { disabledResearcherTFA }) => {
    return umResearcherAdapter.updateOne(
      { changes: disabledResearcherTFA, id: disabledResearcherTFA.id },
      {
        ...state,
      }
    );
  })
);

export function umResearcherReducer(state: UmResearcherState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = umResearcherAdapter.getSelectors();
